export const INPROGRESS = 'INPROGRESS';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const DISPATCH_TIMINGS_VALUES = [
  { key: 0, value: '6:00 PM To 8:00 PM' },
  { key: 1, value: '6:01 PM To 8:01 PM' },
  { key: 2, value: '6:02 PM To 8:02 PM' },
  { key: 3, value: '6:03 PM To 8:03 PM' },
  { key: 4, value: '6:04 PM To 8:04 PM' },
  { key: 5, value: '6:05 PM To 8:05 PM' },
  { key: 6, value: '6:06 PM To 8:06 PM' },
  { key: 7, value: '6:07 PM To 8:07 PM' },
  { key: 8, value: '6:08 PM To 8:08 PM' },
  { key: 9, value: '6:09 PM To 8:09 PM' },
  { key: 10, value: '6:10 PM To 8:10 PM' },
  { key: 11, value: '6:11 PM To 8:11 PM' },
  { key: 12, value: '6:12 PM To 8:12 PM' },
  { key: 13, value: '6:13 PM To 8:13 PM' },
  { key: 14, value: '6:14 PM To 8:14 PM' },
  { key: 15, value: '6:15 PM To 8:15 PM' },
  { key: 16, value: '6:16 PM To 8:16 PM' },
  { key: 17, value: '6:17 PM To 8:17 PM' },
  { key: 18, value: '6:18 PM To 8:18 PM' },
  { key: 19, value: '6:19 PM To 8:19 PM' },
  { key: 20, value: '6:20 PM To 8:20 PM' },
  { key: 21, value: '6:21 PM To 8:21 PM' },
  { key: 22, value: '6:22 PM To 8:22 PM' },
  { key: 23, value: '6:23 PM To 8:23 PM' },
  { key: 24, value: '6:24 PM To 8:24 PM' },
];

export const UNDERLYING_PROGRAM_VALUES = [
  { key: 'NEM', value: 'NEM' },
  { key: 'CGS', value: 'CGS' },
  { key: 'NEM+', value: 'NEM+' },
  { key: 'CGS+', value: 'CGS+' },
  { key: 'CSS', value: 'CSS' },
  { key: 'Smart Export', value: 'Smart Export' },
  { key: 'SIA', value: 'SIA' },
];

export const $perKW = [
  { key: '850.0', value: '850.0' },
  { key: '750.0', value: '750.0' },
  { key: '500.0', value: '500.0' },
];

export const get24HrsFormatValue = (time) => {
  return `${Number(time.split(':')[0]) + 12}:${time.split(':')[1]}`;
};

export const get12HrsFormatValue = (time) => {
  return `${Number(time.split(':')[0]) - 12}:${time.split(':')[1]}`;
};
